import React, { lazy, Suspense } from "react";
import { ThemeProvider, createTheme } from "@mui/material";
import { Routes, Route, Navigate } from "react-router-dom";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "@fontsource/poppins";
import "@fontsource-variable/rubik";
import "./App.css";
import Register from "./pages/Register/Register";
import PreRegister from "./pages/PreRegister/PreRegister";
import Topup from "./pages/Topup/Topup";
import AuthenticatedLayout from "./components/layout/AuthenticatedUserLayout";
import Referral from "./pages/Referral/Referral";
import OnboardingFeedback from "./pages/Feedback/Feedback";
import WealthOnboarding from "./pages/WealthOnboarding/WealthOnboarding";
const Admin = lazy(() => import("./pages/Admin/Admin"));
const Login = lazy(() => import("./pages/Admin/Login/Login"));
const SuccessfulRegistration = lazy(
  () => import("./pages/Register/SuccessfulRegistration/SuccessfulRegistration")
);
const Dashboard = lazy(() => import("./pages/Dashboard/Dashboard"));
const Products = lazy(() => import("./pages/Products/Products"));
const Redemption = lazy(() => import("./pages/Redemption/Redemption"));
// const PreRegister = lazy(() => import("./pages/PreRegister/PreRegister"));
const Transactions = lazy(() => import("./pages/Transactions/Transactions"));

function App() {
  const theme = createTheme({
    palette: {
      primary: {
        main: "#5d2684",
        light: "rgba(93,38,132,0.1)",
      },
      secondary: {
        main: "#FBB807",
      },
    },
    typography: {
      h5: {
        fontSize: 20,
      },
      fontFamily: "'Poppins', sans-serif",
      // fontFamily: "'Rubik Variable', sans-serif",
    },
  });
  return (
    <ThemeProvider theme={theme}>
      <Routes>
        <Route path="*" element={<Navigate to="/select-account" />} />
        <Route
          path="/select-account"
          element={
            // <Suspense fallback="Loading">
            <PreRegister />
            // </Suspense>
          }
        />
        <Route
          path="/register"
          element={
            <Suspense fallback="Loading">
              <Register />
            </Suspense>
          }
        />
        <Route
          path="/register/successful-registration"
          element={
            <Suspense fallback="Loading">
              <SuccessfulRegistration />
            </Suspense>
          }
        />
        <Route
          path="/register/onboarding-feedback"
          element={
            <Suspense fallback="Loading">
              <OnboardingFeedback />
            </Suspense>
          }
        />
        <Route
          path="/register/wealth-onboarding"
          element={
            <Suspense fallback="Loading">
              <WealthOnboarding />
            </Suspense>
          }
        />
        <Route
          path="/admin/*"
          element={
            <Suspense fallback="Loading">
              <Admin />
            </Suspense>
          }
        />
        <Route
          path="/admin/login"
          element={
            <Suspense fallback="Loading">
              <Login />
            </Suspense>
          }
        />

        {/* Authenticated Routes */}
        <Route
          element={
            <AuthenticatedLayout>
              <Routes>
                <Route
                  path="/dashboard"
                  element={
                    <Suspense fallback="Loading">
                      <Dashboard />
                    </Suspense>
                  }
                />
                <Route
                  path="/topup"
                  element={
                    <Suspense fallback="Loading">
                      <Topup />
                    </Suspense>
                  }
                />
                <Route
                  path="/products"
                  element={
                    <Suspense fallback="Loading">
                      <Products />
                    </Suspense>
                  }
                />
                <Route
                  path="/transactions"
                  element={
                    <Suspense fallback="Loading">
                      <Transactions />
                    </Suspense>
                  }
                />
                <Route
                  path="/redemptions"
                  element={
                    <Suspense fallback="Loading">
                      <Redemption />
                    </Suspense>
                  }
                />
                <Route
                  path="/referral"
                  element={
                    <Suspense fallback="Loading">
                      <Referral />
                    </Suspense>
                  }
                />
              </Routes>
            </AuthenticatedLayout>
          }
        ></Route>
      </Routes>
      <ToastContainer />
    </ThemeProvider>
  );
}

export default App;
